import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface AtivityLogItem {
  id: number;
  acaoLogsEnum: number;
  acaoLogs: string;
  username: string;
  email: string;
  nome: string;
  entidadeENUM: number;
  entidade: string;
  tituloRegisto: string;
  campoAlterado: string;
  valorAnterior: string;
  valorNovo: string;
  sucesso: boolean;
  dataCriacao: string;
  dataCriacaoFormatada: string;
}

export interface AtivityLogResponse {
  data: AtivityLogItem[];
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
}

export interface AtivityLogsFilter {
  Nome?: string | null;
  Email?: string | null;
  AcaoLogsEnum?: number | null;
  EntidadeENUM?: number | null;
  DataInicio?: string | Date | null;
  DataFim?: string | Date | null;
  PageNumber?: number;
  PageSize?: number;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class AtivityLogsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiurl}/api/AtivityLogs`;

  getAll(filterParams: AtivityLogsFilter = {}): Observable<AtivityLogResponse> {
    let params = new HttpParams();

    Object.entries(filterParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        if (value instanceof Date) {
          params = params.set(key, value.toISOString());
        } else {
          params = params.set(key, String(value));
        }
      }
    });

    return this.http.get<AtivityLogResponse>(this.baseUrl, { params });
  }

  getById(id: number): Observable<AtivityLogItem> {
    return this.http.get<AtivityLogItem>(`${this.baseUrl}/${id}`);
  }
}
